import { render, staticRenderFns } from "./Confianca.vue?vue&type=template&id=4840bdc8&"
import script from "./Confianca.vue?vue&type=script&lang=js&"
export * from "./Confianca.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports